<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace', 'attachCannedFiles'],
  data() {
    return { falhouAoBuscar: false };
  },
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        attachments: cannedMessage.attachments || [],
        hasAttachments: !!(
          cannedMessage.attachments && cannedMessage.attachments.length > 0
        ),
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    // A busca engolia a falha: quem digitava "/" via a lista NÃO APARECER, que
    // é exatamente o que acontece quando não há resposta pronta cadastrada.
    // Duas causas, uma imagem só — e a pessoa conclui a errada.
    fetchCannedResponses() {
      this.falhouAoBuscar = false;
      this.$store
        .dispatch('getCannedResponse', { searchKey: this.searchKey })
        .catch(() => {
          this.falhouAoBuscar = true;
        });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
      if (item.hasAttachments) {
        this.$emit('attachCannedFiles', item.attachments);
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
  <div
    v-else-if="falhouAoBuscar"
    class="advup-txt-nota text-n-ruby-11 bg-n-solid-1 px-3 py-2 rounded-xl absolute w-full z-20 shadow-md left-0 bottom-full border border-solid border-n-strong"
    role="status"
  >
    {{ $t('CANNED_MGMT.MENTION_LOAD_ERROR') }}
  </div>
</template>
